import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getTheftRegistriesForStoreAction = createAsyncThunk(
    'order/getTheftRegistriesForStoreAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ THEFT_REGISTRIES_PATH }/for-store${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getTheftRegistriesForStoreSlice = createSlice({
    name: 'getTheftRegistriesForStoreSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getTheftRegistriesForStoreAction.pending, () => STATE__API__STARTED);
        builder.addCase(getTheftRegistriesForStoreAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getTheftRegistriesForStoreAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getTheftRegistriesForStoreState = (state) => state.order.getTheftRegistriesForStore;
export default getTheftRegistriesForStoreSlice.reducer;
